export * from './ActorQueryOperationFromQuad';
